module.exports = __webpack_public_path__ + "animoji.1dfa9a90b3.png";